import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "converter" }
const _hoisted_2 = { class: "upload-container" }
const _hoisted_3 = { class: "step-container" }
const _hoisted_4 = { class: "format-container" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "step-container" }
const _hoisted_8 = { class: "target-selector" }
const _hoisted_9 = { class: "target-selector-text" }
const _hoisted_10 = { class: "chosen-format" }
const _hoisted_11 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LandingComp = _resolveComponent("LandingComp")!
  const _component_StatComp = _resolveComponent("StatComp")!
  const _component_RocketIcon = _resolveComponent("RocketIcon")!
  const _component_StepNumber = _resolveComponent("StepNumber")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_FooterComp = _resolveComponent("FooterComp")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LandingComp),
    _createVNode(_component_StatComp, { ref: "statComp" }, null, 512),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RocketIcon),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_StepNumber, { number: 1 }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("Select your source format")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formats, (format, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "format-container-item",
              key: format
            }, [
              (index > 0 && _ctx.isNotMobile)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "|"))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.generateClass(format)),
                onClick: ($event: any) => (_ctx.selectFormat(format))
              }, "." + _toDisplayString(format), 11, _hoisted_6)
            ]))
          }), 128))
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "line" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_StepNumber, { number: 2 }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Select your target format")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _cache[4] || (_cache[4] = _createTextVNode("From ")),
            _createElementVNode("span", _hoisted_10, "." + _toDisplayString(_ctx.chosenFormat), 1),
            _cache[5] || (_cache[5] = _createTextVNode(" to "))
          ]),
          _withDirectives(_createElementVNode("select", {
            name: "selectTarget",
            id: "selectTarget",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetFormat) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formatTargets[_ctx.chosenFormat], (f) => {
              return (_openBlock(), _createElementBlock("option", {
                value: f,
                key: f
              }, "." + _toDisplayString(f), 9, _hoisted_11))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.targetFormat]
          ])
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "line" }, null, -1))
      ]),
      _createVNode(_component_FileUpload, {
        onUpdateStats: _ctx.updateStatsParent,
        sourceFormat: _ctx.chosenFormat,
        targetFormat: _ctx.targetFormat,
        ref: "fileUploadRef",
        clearParentInputs: _ctx.clearParentInputs
      }, null, 8, ["onUpdateStats", "sourceFormat", "targetFormat", "clearParentInputs"])
    ]),
    _createVNode(_component_FooterComp)
  ]))
}